<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';

const { t } = useI18n()

</script>

<template>
    <button type="submit"
        class="flex w-full justify-center rounded-lg bg-sky-500 py-3 px-4 mt-5 font-bold text-white hover:bg-sky-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600 shadow-[4px_4px_0_0_rgba(0,0,0,0.07)] transition-all">
        {{ t(TEXT.login) }}
    </button>
</template>

<style scoped></style>